var FormTemplate = /** @class */ (function () {
    function FormTemplate() {
    }
    FormTemplate.input = function (name, value, attributes) {
        if (value === void 0) { value = null; }
        if (attributes === void 0) { attributes = {}; }
        var input = document.createElement('input');
        input.setAttribute('name', name);
        if (value) {
            input.value = value;
        }
        attributes = Object.assign({}, {
            type: 'text'
        }, attributes);
        FormTemplate.setHtmlAttributes(input, attributes);
        return input;
    };
    FormTemplate.textarea = function (name, value, attributes) {
        if (value === void 0) { value = 'ss'; }
        if (attributes === void 0) { attributes = {}; }
        var textarea = document.createElement('textarea');
        textarea.setAttribute('name', name);
        FormTemplate.setHtmlAttributes(textarea, attributes);
        return textarea;
    };
    FormTemplate.checkbox = function (name, value, label) {
        var input = document.createElement('label');
        input.classList.add('input__checkbox');
        input.innerHTML = "<input type=\"checkbox\" name=\"" + name + "\" class=\"input__checkbox__input\" value=\"" + value + "\"><span class=\"input__checkbox__label\">" + label + "</span>";
        return input;
    };
    FormTemplate.setHtmlAttributes = function (input, attributes) {
        Object.keys(attributes).forEach(function (attribute) {
            var value = attributes[attribute];
            input.setAttribute(attribute, value);
        });
    };
    FormTemplate.inputGroup = function (label, input) {
        return "\n\t\t<div class=\"input__group\">\n\t\t\t<label>" + label + "</label>\n\t\t\t<div class=\"input__controlgroup\">" + input + "</div>\n\t\t</div>\n\t\t";
    };
    return FormTemplate;
}());
export default FormTemplate;
